import { render, staticRenderFns } from "./AssociatedRealName.vue?vue&type=template&id=3d95e5fc&scoped=true&"
import script from "./AssociatedRealName.vue?vue&type=script&lang=js&"
export * from "./AssociatedRealName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95e5fc",
  null
  
)

export default component.exports